import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument.js"; // Assuming a custom log function

// Function to initiate a payment
const initiatePayment = async (folder_id, payment_id, token, prefix) => {
  // Define the endpoint URL
  const url = prefix + "actions/initiate-payment";

  // Define the request body
  const body = {
    folder_id: folder_id,
    payment_id: payment_id,
  };

  // Define headers
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    let start = new Date();
    // Make the POST request
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body), // Encode the body as JSON
    });

    const auth = getAuthCentral();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      return "User not logged in";
    }

    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));

    if (!userSnapshot.exists()) {
      return "User document not found";
    }

    const org_id = userSnapshot.get("org_id");
    const responseText = await response.text();
    let end = new Date();
    let time = end - start;
    // Log the request and response
    await addLogDocument(
      url,
      prefix,
      userRef,
      org_id,
      response.status.toString(),
      folder_id || "",

      "",
      JSON.stringify(body), // Request body as a string
      responseText,
      "POST",
      time
    );

    // Check if the request was successful
    if (response.ok) {
      return "Payment initiated successfully"; // Return success message
    } else {
      console.error(`Failed to initiate payment: ${response.status}`);
      return `Failed to initiate payment: ${response.status}`;
    }
  } catch (error) {
    // Handle exceptions
    console.error(`Exception occurred: ${error.message}`);
    return `Exception: ${error.message}`;
  }
};

export default initiatePayment;
